module.exports = __webpack_public_path__ + "static/metropolitana.784c50e8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/partners/metropolitana.jpeg
// module id = 1616
// module chunks = 35783957827783